import React, { useEffect, useState } from "react";
import "./RecommendationsTable.css";
import RecommendationEditForm from "./RecommendationEditForm/RecommendationEditForm";
import RecommendationCreateForm from "./RecommendationCreateForm/RecommendationCreateForm";
import { MdEdit } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";

function RecommendationsTable({ fetchQuizQuestions }) {
  const [recommendations, setRecommendations] = useState([]);
  const [createNewRec, setCreateNewRec] = useState(false);
  const [editRec, setEditRec] = useState(null);
  const [deleteRec, setDeleteRec] = useState(null);

  // Fetch all recommendations
  const fetchRecommendations = () => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/recommendations`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => setRecommendations(data))
      .catch((err) => console.error("Error fetching recommendations:", err));
  };

  useEffect(() => {
    fetchRecommendations();
  }, []);

  // Create recommendation
  const handleCreate = (recData) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/recommendations/add`,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(recData),
      }
    ).then(() => {
      setCreateNewRec(false);
      fetchRecommendations();
      alert("Recommendation has been created!");
    });
  };

  // Edit recommendation
  const handleEdit = (recId, recData) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/recommendations/edit/${recId}`,
      {
        method: "PUT",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(recData),
      }
    ).then(() => {
      setEditRec(null);
      fetchRecommendations();
      alert("Recommendation has been updated!");
    });
  };

  // Delete recommendation
  const handleDelete = (recId) => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/recommendations/delete/${recId}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    ).then(() => {
      setDeleteRec(null);
      fetchRecommendations();
      fetchQuizQuestions();
      alert("Recommendation has been deleted!");
    });
  };

  return (
    <div className="recommendations-table">
      <div className="table-header">
        <h3>Recommendations</h3>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
      >
        <div />
        <button onClick={() => setCreateNewRec(true)}>
          Create New Recommendation
        </button>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th style={{ width: "80px" }}>ID</th>
              <th>Heading</th>
              <th>Text</th>
              <th
                style={{
                  width: "40px",
                  minWidth: "40px",
                }}
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {recommendations.map((rec, idx) => (
              <tr key={rec.id}>
                <td
                  style={{
                    width: "40px",
                    minWidth: "40px",
                    textAlign: "center",
                  }}
                >
                  {rec.id}
                </td>
                <td>{rec.heading}</td>
                <td>{rec.text}</td>
                <td
                  style={{
                    width: "40px",
                    minWidth: "40px",
                  }}
                >
                  {/* Just for user testing, ensure they can't remove the pre-set recommendations. They can edit and remove their own created recommendations though. */}
                  <span style={{ display: "inline-flex", gap: "0.5rem" }}>
                    <button
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => setEditRec(rec)}
                    >
                      <MdEdit />
                    </button>
                    <button
                      className="red-button"
                      style={{ display: "flex", alignItems: "center" }}
                      onClick={() => setDeleteRec(rec)}
                    >
                      <FaTrashAlt />
                    </button>
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Create Modal */}
      {createNewRec && (
        <RecommendationCreateForm
          onClose={() => setCreateNewRec(false)}
          onSave={handleCreate}
        />
      )}

      {/* Edit Modal */}
      {editRec && (
        <RecommendationEditForm
          recommendation={editRec}
          onClose={() => setEditRec(null)}
          onSave={(data) => handleEdit(editRec.id, data)}
        />
      )}

      {/* Delete Modal */}
      {deleteRec && (
        <div className="modal">
          <div className="modal-content">
            <button className="modal-close" onClick={() => setDeleteRec(null)}>
              ×
            </button>
            <h3>Confirm Deletion</h3>
            <p>
              Are you sure you want to delete this recommendation? This will
              also remove all the questions linked to this recommendation.
            </p>
            <p>
              <b>{deleteRec.id}: </b>
              <i>{deleteRec.text}</i>
            </p>
            <div className="modal-buttons">
              <button
                className="red-button"
                onClick={() => handleDelete(deleteRec.id)}
              >
                Delete
              </button>
              <button onClick={() => setDeleteRec(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default RecommendationsTable;
